import React, { useEffect, useState } from "react";
import { Link, Navigate, NavLink } from "react-router-dom";
import styled, { css } from "styled-components";
import { Sidebar, Menu, MenuItem, SubMenu, menuClasses } from "react-pro-sidebar";
import Typography from "../atoms/Typography";
import UserProfile from "../molecules/UserProfile";
import { useSelector } from "react-redux";

/**
 * [SideBar 참고] https://github.com/azouaoui-med/react-pro-sidebar/
 */
const Nav = (props) => {
  const user = useSelector(state => state.auth.user)
  // 메뉴 접근 권한 - 0: 일반, 1: 중간, 2: 최고
  const userGrade = user.grade

  // 윈도우 크기 변경 감지 (768px 이하일 떄 isNarrow = true, 다른 값을 원하면 호출시 breakpoint 인자로 지정)
  const useIsNarrow = (breakpoint = 768) => {
    const [isNarrow, setIsNarrow] = useState(window.innerWidth < breakpoint)

    useEffect(() => {
      const onResize = () => {
        setIsNarrow(window.innerWidth < breakpoint)
      }
      window.addEventListener('resize', onResize)
      return () => {
        window.removeEventListener('resize', onResize)
      }
    }, [breakpoint])

    return isNarrow
  }
  const isNarrow = useIsNarrow()

  return (
    <MainWrapper>
      <Sidebar
        width="280px"
        collapsed={isNarrow}
        // image="https://cdn.pixabay.com/photo/2017/08/28/17/03/sky-2690419_1280.jpg"
        backgroundColor="var(--bg-light)"
        breakPoint="xs"
      >
        <SidebarContentWrapper>
          <SidebarContent>
          {/* 헤더 영역 */}
            <SidebarHeader>
              <HeaderContent>
                <Link to="/home">
                  <Typography variant="h4" fontWeight={800} color="var(--main-dark-color)" style={{letterSpacing: "1px"}}>AIRS</Typography>
                </Link>
                <UserProfile user={ user } style={{marginTop: "20px"}} />
              </HeaderContent>
            </SidebarHeader>

          {/* 공통 메뉴 */}
          <Menu
            menuItemStyles={sidebarMenuThemes}
            closeOnClick="true"
          >
            {/* <SubMenu label="리뷰" icon={<Icon icon="bi-pencil-square" />} defaultOpen={true}> */}
            <SubMenu label="리뷰" icon={<Icon src="/image/icn_review.svg" />} defaultOpen={true}>
              <MenuItem component={<NavLink to="/review/list" />} >참여할 리뷰</MenuItem>
              <MenuItem component={<NavLink to="/review/result/list" />}>받은 리뷰</MenuItem>
            </SubMenu>
            {/* <SubMenu label="그룹" icon={<IconFromBootstrap icon="bi-people-fill" />} defaultOpen={true}> */}
            <SubMenu label="그룹" icon={<Icon src="/image/icn_group.svg" />} defaultOpen={true}>
              <MenuItem component={<NavLink to="/group/list" />}>그룹 목록</MenuItem>
            </SubMenu>
          </Menu>

          {/* 관리자 메뉴 */}
          {(userGrade === "1" || userGrade === "2") && (
            <>
              <AdminMenuHeader style={{opacity: isNarrow ? 0 : 1}}>
                관리 메뉴
              </AdminMenuHeader>
              <Menu
                menuItemStyles={sidebarMenuThemes}
                closeOnClick="true"
              >
                {userGrade === "2" && (
                  // <SubMenu label="리뷰" icon={<IconFromBootstrap icon="bi-pencil-square" />} defaultOpen={true}>
                  <SubMenu label="리뷰" icon={<Icon src="/image/icn_review.svg" />} defaultOpen={true}>
                    <MenuItem component={<NavLink to="admin/review/list" />}>리뷰 목록</MenuItem>
                    {/* <MenuItem component={<NavLink to="admin/review/result/list" />}>리뷰 결과 목록</MenuItem> */}
                    {/* <MenuItem component={<NavLink to="admin/review/create" />}>리뷰 생성</MenuItem> */}
                  </SubMenu>
                )}
                {/* <SubMenu label="그룹" icon={<IconFromBootstrap icon="bi-people-fill" />} > */}
                <SubMenu label="그룹" icon={<Icon src="/image/icn_group.svg" />} defaultOpen={true}>
                  <MenuItem component={<NavLink to="admin/group/list" />}>그룹 목록</MenuItem>
                  {/* {userGrade === "2" && (
                    <MenuItem component={<NavLink to="admin/group/create" />}>그룹 생성</MenuItem>
                  )} */}
                </SubMenu>
                {userGrade === "2" && (
                  <SubMenu label="유저" icon={<IconFromBootstrap icon="bi-person-circle" />} defaultOpen={true}>
                    <MenuItem component={<NavLink to="admin/user/list" />}>유저 목록</MenuItem>
                  </SubMenu>
                )}
              </Menu>
            </>
          )}
          </SidebarContent>
          <FooterText>APPKNOT © 2025</FooterText>
        </SidebarContentWrapper>
      </Sidebar>
    </MainWrapper>
  )
}

// 사이드바 테마
const sidebarMenuThemes = {
  root: {
    // 모든 아이템의 기본 폰트 사이즈
    [`& .${menuClasses.button}`]: {
      fontSize: '16px',
    },
    [`& .${menuClasses.icon}`]: {
      width: "auto",
      minWidth: "auto",
      margin: "-4px 12px 0 8px",
    },
  },

  // SubMenu
  button: ({ level, active, disabled }) => {
    if (level === 1) return {
      padding: '14px 16px 14px 20px',
      backgroundColor: 'transparent',  
      borderRadius: '4px',
      '&:hover': {
        color: 'var(--dark-color)',
        backgroundColor: 'var(--bg-blue)',
      },
    }
  },
  label: ({ level, active, disabled }) => {
    if (level === 0) return {
      fontWeight: 600,
    }
  },

  // SubMenu - MenuItem
  subMenuContent: ({ level, open }) => ({
    backgroundColor: 'transparent',
    [`& .${menuClasses.button}`]: {
      margin: '0 20px 0 40px',
      padding: '14px 12px',
    },
    [`& .${menuClasses.button}.active`]: {
      backgroundColor: 'var(--bg-blue)',
    },
    [`& .${menuClasses.label}`]: {
      fontWeight: 500,
      color: 'var(--text-color)',
    },
    [`& .${menuClasses.button}.active .${menuClasses.label}`]: {
      color: 'var(--main-point-color)',
    },
  })
}

// 상위 전체 Wrapper (화면 높이 100vh, flex 컨테이너)
const MainWrapper = styled.div`
  display: flex;
  height: 100%;
`;

// Sidebar 헤더 스타일
const SidebarHeader = styled.div`
  padding: 20px;
`;

// Sidebar 내부에서 헤더 컨텐츠를 감싸는 컨테이너 (column, center 정렬)
const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

// Sidebar 내부 Content 전체 Wrapper (column, 100% 높이) - 하단 APPKNOT 로고 배치를 위함
const SidebarContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const AdminMenuHeader = styled.div`
  font-weight: 700;
  color: var(--gray3-color);
  padding: 15px 20px;
  margin-top: 40px;
  letter-spacing: 0.05em;
`;

const SidebarContent = styled.div`
    flex: 1;
    overflow-y: auto;
  `

const IconFromBootstrap = styled.i.attrs(({ icon, className }) => ({
  className: [
    "bi",
    icon && `${icon}`,
    className
  ]
    .filter(Boolean)
    .join(" ")
}))`
  width: 20px;
  height: 20px;
  font-size: 1em;
  color: var(--deep-dark-color);
`

const Icon = styled.img`
  width: 20px;
  height: 20px;
`

const FooterText = styled.p`
  font-family: 'Gotham';
  position: relative;
  width: 100%;
  padding: 18px 20px;
  text-align: left;
  font-size: 12px;
  color: var(--gray3-color, #777);
  letter-spacing: 0.5px;
`

export default Nav